import { EnderecoFabrilVO } from ".";

export class EmpresaVO {

  idComposicaoRda: number;
  idUnicoPessoaJuridica: number;
  cnpj: string;
  razaoSocial: string;
  tipo: string;
  enderecoFabrilVO: EnderecoFabrilVO;
  responsavelPreenchimento: boolean;
  suspensaRda: boolean;
  suspensaAuditoria: boolean;
  gerouTrimestral: boolean;

}
